/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addEvent = /* GraphQL */ `
  mutation AddEvent(
    $countryCode: String
    $eventDate: AWSDate
    $eventName: String!
    $landingPageConfig: landingPageConfigInputType
    $raceConfig: RaceInputConfig!
    $sponsor: String
    $tracks: [TrackInput]!
    $typeOfEvent: TypeOfEvent!
  ) {
    addEvent(
      countryCode: $countryCode
      eventDate: $eventDate
      eventName: $eventName
      landingPageConfig: $landingPageConfig
      raceConfig: $raceConfig
      sponsor: $sponsor
      tracks: $tracks
      typeOfEvent: $typeOfEvent
    ) {
      countryCode
      createdAt
      createdBy
      eventDate
      eventId
      eventName
      landingPageConfig {
        links {
          linkDescription
          linkHref
          linkName
        }
      }
      raceConfig {
        maxRunsPerRacer
        numberOfResetsPerLap
        raceTimeInMin
        rankingMethod
        trackType
      }
      sponsor
      tracks {
        fleetId
        leaderBoardFooter
        leaderBoardTitle
        trackId
      }
      typeOfEvent
    }
  }
`;
export const addFleet = /* GraphQL */ `
  mutation AddFleet($carIds: [String], $fleetName: String!) {
    addFleet(carIds: $carIds, fleetName: $fleetName) {
      carIds
      createdAt
      createdBy
      fleetId
      fleetName
    }
  }
`;
export const addLeaderboardEntry = /* GraphQL */ `
  mutation AddLeaderboardEntry(
    $avgLapTime: Float
    $avgLapsPerAttempt: Float
    $countryCode: String
    $eventId: ID!
    $fastestLapTime: Float
    $lapCompletionRatio: Float
    $numberOfInvalidLaps: Int
    $numberOfValidLaps: Int
    $racedByProxy: Boolean!
    $trackId: ID!
    $username: String!
  ) {
    addLeaderboardEntry(
      avgLapTime: $avgLapTime
      avgLapsPerAttempt: $avgLapsPerAttempt
      countryCode: $countryCode
      eventId: $eventId
      fastestLapTime: $fastestLapTime
      lapCompletionRatio: $lapCompletionRatio
      numberOfInvalidLaps: $numberOfInvalidLaps
      numberOfValidLaps: $numberOfValidLaps
      racedByProxy: $racedByProxy
      trackId: $trackId
      username: $username
    ) {
      avgLapTime
      avgLapsPerAttempt
      countryCode
      eventId
      fastestLapTime
      lapCompletionRatio
      numberOfInvalidLaps
      numberOfValidLaps
      racedByProxy
      trackId
      username
    }
  }
`;
export const addModel = /* GraphQL */ `
  mutation AddModel(
    $modelKey: String!
    $racerIdentityId: String!
    $racerName: String!
  ) {
    addModel(
      modelKey: $modelKey
      racerIdentityId: $racerIdentityId
      racerName: $racerName
    ) {
      md5DateTime
      modelFilename
      modelId
      modelKey
      modelMD5
      modelMetadataMD5
      racerIdentityId
      racerName
      uploadedDateTime
    }
  }
`;
export const addRace = /* GraphQL */ `
  mutation AddRace(
    $eventId: ID!
    $laps: [LapInput]!
    $racedByProxy: Boolean!
    $trackId: ID!
    $userId: ID!
  ) {
    addRace(
      eventId: $eventId
      laps: $laps
      racedByProxy: $racedByProxy
      trackId: $trackId
      userId: $userId
    ) {
      createdAt
      eventId
      laps {
        autTimerConnected
        isValid
        lapId
        resets
        time
      }
      raceId
      racedByProxy
      trackId
      userId
    }
  }
`;
export const carActivation = /* GraphQL */ `
  mutation CarActivation(
    $carUiPassword: String!
    $fleetId: ID!
    $fleetName: String!
    $hostname: String!
  ) {
    carActivation(
      carUiPassword: $carUiPassword
      fleetId: $fleetId
      fleetName: $fleetName
      hostname: $hostname
    ) {
      activationCode
      activationId
      region
    }
  }
`;
export const carDeleteAllModels = /* GraphQL */ `
  mutation CarDeleteAllModels($resourceIds: [String!]) {
    carDeleteAllModels(resourceIds: $resourceIds)
  }
`;
export const carEmergencyStop = /* GraphQL */ `
  mutation CarEmergencyStop($resourceIds: [String!]) {
    carEmergencyStop(resourceIds: $resourceIds)
  }
`;
export const carRestartService = /* GraphQL */ `
  mutation CarRestartService($resourceIds: [String!]) {
    carRestartService(resourceIds: $resourceIds)
  }
`;
export const carSetTaillightColor = /* GraphQL */ `
  mutation CarSetTaillightColor(
    $resourceIds: [String!]
    $selectedColor: String!
  ) {
    carSetTaillightColor(
      resourceIds: $resourceIds
      selectedColor: $selectedColor
    )
  }
`;
export const carUpdates = /* GraphQL */ `
  mutation CarUpdates(
    $fleetId: String!
    $fleetName: String!
    $resourceIds: [String!]
  ) {
    carUpdates(
      fleetId: $fleetId
      fleetName: $fleetName
      resourceIds: $resourceIds
    )
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $countryCode: String!
    $email: String!
    $username: String!
  ) {
    createUser(countryCode: $countryCode, email: $email, username: $username) {
      Attributes {
        Name
        Value
      }
      Enabled
      MFAOptions {
        Name
        Value
      }
      Roles
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      sub
    }
  }
`;
export const deleteEvents = /* GraphQL */ `
  mutation DeleteEvents($eventIds: [String]!) {
    deleteEvents(eventIds: $eventIds)
  }
`;
export const deleteFleets = /* GraphQL */ `
  mutation DeleteFleets($fleetIds: [String]!) {
    deleteFleets(fleetIds: $fleetIds) {
      carIds
      createdAt
      createdBy
      fleetId
      fleetName
    }
  }
`;
export const deleteLeaderboardEntry = /* GraphQL */ `
  mutation DeleteLeaderboardEntry(
    $eventId: ID!
    $trackId: ID!
    $username: String!
  ) {
    deleteLeaderboardEntry(
      eventId: $eventId
      trackId: $trackId
      username: $username
    ) {
      avgLapTime
      avgLapsPerAttempt
      countryCode
      eventId
      fastestLapTime
      lapCompletionRatio
      numberOfInvalidLaps
      numberOfValidLaps
      racedByProxy
      trackId
      username
    }
  }
`;
export const deleteRaces = /* GraphQL */ `
  mutation DeleteRaces($eventId: ID!, $racesToDelete: [RaceDeleteInput]!) {
    deleteRaces(eventId: $eventId, racesToDelete: $racesToDelete) {
      eventId
      raceIds
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser($username: String!) {
    deleteUser(username: $username) {
      Deleted
      Username
    }
  }
`;
export const updateEvent = /* GraphQL */ `
  mutation UpdateEvent(
    $countryCode: String
    $eventDate: AWSDate
    $eventId: String!
    $eventName: String!
    $landingPageConfig: landingPageConfigInputType
    $raceConfig: RaceInputConfig!
    $sponsor: String
    $tracks: [TrackInput]!
    $typeOfEvent: TypeOfEvent!
  ) {
    updateEvent(
      countryCode: $countryCode
      eventDate: $eventDate
      eventId: $eventId
      eventName: $eventName
      landingPageConfig: $landingPageConfig
      raceConfig: $raceConfig
      sponsor: $sponsor
      tracks: $tracks
      typeOfEvent: $typeOfEvent
    ) {
      countryCode
      createdAt
      createdBy
      eventDate
      eventId
      eventName
      landingPageConfig {
        links {
          linkDescription
          linkHref
          linkName
        }
      }
      raceConfig {
        maxRunsPerRacer
        numberOfResetsPerLap
        raceTimeInMin
        rankingMethod
        trackType
      }
      sponsor
      tracks {
        fleetId
        leaderBoardFooter
        leaderBoardTitle
        trackId
      }
      typeOfEvent
    }
  }
`;
export const updateFleet = /* GraphQL */ `
  mutation UpdateFleet($carIds: [ID], $fleetId: String!, $fleetName: String) {
    updateFleet(carIds: $carIds, fleetId: $fleetId, fleetName: $fleetName) {
      carIds
      createdAt
      createdBy
      fleetId
      fleetName
    }
  }
`;
export const updateLeaderboardEntry = /* GraphQL */ `
  mutation UpdateLeaderboardEntry(
    $avgLapTime: Float
    $avgLapsPerAttempt: Float
    $countryCode: String
    $eventId: ID!
    $fastestLapTime: Float
    $lapCompletionRatio: Float
    $numberOfInvalidLaps: Int
    $numberOfValidLaps: Int
    $racedByProxy: Boolean!
    $trackId: ID!
    $username: String!
  ) {
    updateLeaderboardEntry(
      avgLapTime: $avgLapTime
      avgLapsPerAttempt: $avgLapsPerAttempt
      countryCode: $countryCode
      eventId: $eventId
      fastestLapTime: $fastestLapTime
      lapCompletionRatio: $lapCompletionRatio
      numberOfInvalidLaps: $numberOfInvalidLaps
      numberOfValidLaps: $numberOfValidLaps
      racedByProxy: $racedByProxy
      trackId: $trackId
      username: $username
    ) {
      avgLapTime
      avgLapsPerAttempt
      countryCode
      eventId
      fastestLapTime
      lapCompletionRatio
      numberOfInvalidLaps
      numberOfValidLaps
      racedByProxy
      trackId
      username
    }
  }
`;
export const updateModel = /* GraphQL */ `
  mutation UpdateModel(
    $md5DateTime: String
    $modelFilename: String
    $modelId: String!
    $modelKey: String!
    $modelMD5: String
    $modelMetadataMD5: String
    $uploadedDateTime: String
  ) {
    updateModel(
      md5DateTime: $md5DateTime
      modelFilename: $modelFilename
      modelId: $modelId
      modelKey: $modelKey
      modelMD5: $modelMD5
      modelMetadataMD5: $modelMetadataMD5
      uploadedDateTime: $uploadedDateTime
    ) {
      md5DateTime
      modelFilename
      modelId
      modelKey
      modelMD5
      modelMetadataMD5
      racerIdentityId
      racerName
      uploadedDateTime
    }
  }
`;
export const updateOverlayInfo = /* GraphQL */ `
  mutation UpdateOverlayInfo(
    $currentLapTimeInMs: Float
    $eventId: ID!
    $eventName: String
    $laps: [LapInput]
    $raceStatus: RaceStatusEnum!
    $timeLeftInMs: Float
    $trackId: ID
    $userId: String
    $username: String
  ) {
    updateOverlayInfo(
      currentLapTimeInMs: $currentLapTimeInMs
      eventId: $eventId
      eventName: $eventName
      laps: $laps
      raceStatus: $raceStatus
      timeLeftInMs: $timeLeftInMs
      trackId: $trackId
      userId: $userId
      username: $username
    ) {
      currentLapTimeInMs
      eventId
      eventName
      laps {
        autTimerConnected
        isValid
        lapId
        resets
        time
      }
      raceStatus
      timeLeftInMs
      trackId
      userId
      username
    }
  }
`;
export const updateRace = /* GraphQL */ `
  mutation UpdateRace(
    $eventId: ID!
    $laps: [LapInput]!
    $raceId: ID!
    $racedByProxy: Boolean!
    $trackId: ID!
    $userId: ID!
  ) {
    updateRace(
      eventId: $eventId
      laps: $laps
      raceId: $raceId
      racedByProxy: $racedByProxy
      trackId: $trackId
      userId: $userId
    ) {
      createdAt
      eventId
      laps {
        autTimerConnected
        isValid
        lapId
        resets
        time
      }
      raceId
      racedByProxy
      trackId
      userId
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser($roles: [String]!, $username: String!) {
    updateUser(roles: $roles, username: $username) {
      Attributes {
        Name
        Value
      }
      Enabled
      MFAOptions {
        Name
        Value
      }
      Roles
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      sub
    }
  }
`;
export const uploadModelToCar = /* GraphQL */ `
  mutation UploadModelToCar($entry: UploadModelToCarInput!) {
    uploadModelToCar(entry: $entry) {
      carInstanceId
      modelKey
      ssmCommandId
    }
  }
`;
export const userCreated = /* GraphQL */ `
  mutation UserCreated(
    $Attributes: [UserObjectAttributesInput]
    $Enabled: Boolean
    $MFAOptions: [UsersObjectMfaOptionsInput]
    $UserCreateDate: AWSDateTime
    $UserLastModifiedDate: AWSDateTime
    $UserStatus: String
    $Username: String
    $sub: ID
  ) {
    userCreated(
      Attributes: $Attributes
      Enabled: $Enabled
      MFAOptions: $MFAOptions
      UserCreateDate: $UserCreateDate
      UserLastModifiedDate: $UserLastModifiedDate
      UserStatus: $UserStatus
      Username: $Username
      sub: $sub
    ) {
      Attributes {
        Name
        Value
      }
      Enabled
      MFAOptions {
        Name
        Value
      }
      Roles
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      sub
    }
  }
`;
